// extracted by mini-css-extract-plugin
export var component = "posts-module--component--zHltZ";
export var posts = "posts-module--posts--3U2It";